import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import DataTable, { TableVisibility } from '@/components/data-table/DataTable';
import { Options } from '@/components/mi-dialog/MiDialog';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import CreateDialog from '@/views/Settings/Seasons/CreateDialog';
import { Season } from '@/models/Season';

@Component<Seasons>({
  components: {
    CreateDialog,
  },
})
export default class Seasons extends Vue {
  @Ref()
  protected seasonsDatatable!: DataTable;

  protected selectedSeason: Season | null = null;

  protected isCreatingSeason: boolean = false;

  protected visibility: TableVisibility = {
    title: false,
    checkboxes: false,
    search: true,
  }

  protected mounted() {}

  protected refreshDatatable(): void {
    this.seasonsDatatable.refresh();
  }

  get tableOptions(): Object {
    return {
      model: new Season(),
      name: {
        singular: 'Season',
        plural: 'Seasons',
      },
      sort: {
        key: 'name',
        order: 'ASC',
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: {
            key: 'name',
            order: 'ASC',
          },
        },
      ],
      actions: [
        {
          type: 'edit',
          label: 'edit',
          icon: 'edit',
          action: (datatable: DataTable, season: Season) => {
            this.selectedSeason = season;
            this.isCreatingSeason = true;
          },
        },
        {
          type: 'delete',
          label: 'delete',
          icon: 'delete',
          action: (datatable: DataTable, season: Season) => {
            this.selectedSeason = season;
            this.$store.dispatch('openDialog', this.dialogOptions);
          },
        },
      ],
      add: () => {
        this.isCreatingSeason = true;
      }
    };
  }

  get dialogOptions(): Options {
    return {
      title: (this.selectedSeason as Season).name || 'Confirm deletion',
      text: 'Are you sure you wish to delete this season?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedSeason) {
              return;
            }

            this.selectedSeason
              .delete()
              .then((response: any) => {
                if (response) {
                  this.seasonsDatatable ? this.seasonsDatatable.refresh(true) : null;
                  this.selectedSeason = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedSeason = null;
          },
        },
      },
    };
  }

  @Watch('isCreatingSeason')
  protected isCreatingSeasonChanged() {
    if(!this.isCreatingSeason) {
      this.selectedSeason = null;
    }
  }
}
